import React from "react";
import moment from "moment";
import { KENDO_DATE_FORMAT } from "../../../../constants";
import { Box, Tooltip } from "@material-ui/core";

const TargetCreatedAt = (colProps) => {
  return (
    <td className="truncate-txt">
      <Box display={"flex"} alignItems="center" justifyContent="center">
        <Tooltip
          title={moment(colProps.dataItem.createdAt).format(KENDO_DATE_FORMAT)}
        >
          <span>
            {moment(colProps.dataItem.createdAt).format(KENDO_DATE_FORMAT)}
          </span>
        </Tooltip>
      </Box>
    </td>
  );
};

export default TargetCreatedAt;
